import './left-pane.styles.scss';
export const LoginLeftPane = () => {
	return (
		<div className="overflow-hidden h-100">
			<div className="side-bar h-100">
				<div className="d-flex flex-column justify-content-center">
				<p className="side-bar-header">Insights with the power to transform</p>
				<p className="side-bar-footer">Unlock potential with assessments that create self-awareness and a roadmap for growth</p>
				</div>

				<div className="bg-img"></div>
			</div>
		</div>
	);
}